import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { pick } from 'lodash';
import { Table } from '@components';
import JobActions, { thunks } from '@redux/jobs';
import { Loader } from '@components/common';
import { JobHistoryColumns, JobHistoryDetailColumns } from './tableColumns';

class JobHistoryModal extends Component {
	constructor(props) {
		super(props);
		const { timeZoneId } = props;

		this.jobHistoryColumns = JobHistoryColumns(timeZoneId, this.handleDetails);
		this.jobHistoryDetailsColumns = JobHistoryDetailColumns(timeZoneId);
	}

	onClose = () => {
		const { resetModal } = this.props;

		resetModal('jobHistoryModal');
	}

	getJobHistory = () => {
		const { getJobHistory, settings : { jobId } } = this.props;

		getJobHistory(jobId);
	}

	handleDetails = (index) => () => {
		const { setJobHistoryDetails, setModalSettings, settings } = this.props;
		setJobHistoryDetails(index);
		setModalSettings('jobHistoryModal', {
			...settings,
			showDetails : true,
		});
	}

	toggleDetails = () => {
		const { setModalSettings, settings } = this.props;
		setModalSettings('jobHistoryModal', {
			...settings,
			showDetails : false,
		});
	}

	render() {
		const {
			show, data, settings : { showDetails }, detailsData, isLoading,
		} = this.props;

		return (
			<Modal
				bsSize="large"
				show={show}
				onHide={this.onClose}
				onEnter={this.getJobHistory}
			>
				<Modal.Header closeButton>
					<Modal.Title>Job History</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Table
						columns={showDetails ? this.jobHistoryDetailsColumns : this.jobHistoryColumns}
						data={showDetails ? detailsData : data}
					/>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={this.onClose}>Close</Button>
					<If condition={showDetails}>
						<Button onClick={this.toggleDetails}>Go Back</Button>
					</If>
				</Modal.Footer>
				<Loader active={isLoading} />
			</Modal>
		);
	}
}

const mapStateToProps = ({
	app: { user : { TimeZoneId: timeZoneId } },
	jobs : {
		loaders : {
			jobHistoryModal : isLoading,
		},
		modals : {
			jobHistoryModal : {
				show,
				data,
				detailsData,
				settings,
			},
		},
	},
}) => ({
	show,
	settings,
	data,
	detailsData,
	timeZoneId,
	isLoading,
});

const mapDispatchToProps = (dispatch) => ({
	...pick(bindActionCreators(JobActions, dispatch), [
		'setModalOpen',
		'setModalSettings',
		'setJobHistoryDetails',
		'resetModal',
	]),
	...pick(bindActionCreators(thunks, dispatch), ['getJobHistory']),
});

JobHistoryModal.propTypes = {
	data                 : PropTypes.array,
	detailsData          : PropTypes.array,
	getJobHistory        : PropTypes.func.isRequired,
	isLoading            : PropTypes.bool,
	resetModal           : PropTypes.func.isRequired,
	setJobHistoryDetails : PropTypes.func.isRequired,
	setModalSettings     : PropTypes.func.isRequired,
	settings             : PropTypes.object,
	show                 : PropTypes.bool,
	timeZoneId           : PropTypes.string,
};

JobHistoryModal.defaultProps = {
	data        : [],
	detailsData : [],
	isLoading   : false,
	settings    : {},
	show        : false,
	timeZoneId  : '',
};

export default connect(mapStateToProps, mapDispatchToProps)(JobHistoryModal);
